// @flow
import mapValues from 'lodash/mapValues';
import get from 'lodash/get';

/**
 * COPIED FROM EndUserApp src/lib/resin/resin.js
 */

/* eslint-disable no-console */

// resinjs isn't a true node package--it dumps itself into window.Resin.
// Treat resin as a library that can be imported. This helps with testing (can rewire Resin), and
// when Resin is pulled in as an actual separate lib we don't have to change our imports.
import 'resinjs/lib/resin';

import resinize from './resinize';

const { Resin } = window;

// Since this is debug code, we are not unit testing this
/* istanbul ignore next */
Resin.logToConsole = (data: Object) => {
  // Note: Only component and feature can be null/undefined
  const fullTag = `${data.client}-${data.application}-${
    data.page
  }-${data.component || ''}-${data.feature || ''}-${data.target} (${
    data.action
  })`;

  console.groupCollapsed(`Resin: ${fullTag}`);

  console.group('Tags');
  console.log(`client: ${data.client}`);
  console.log(`application: ${data.application}`);
  console.log(`page: ${data.page}`);
  console.log(`component: ${data.component}`);
  console.log(`feature: ${data.feature}`);
  console.log(`target: ${data.target}`);
  console.log(`action: ${data.action}`);
  if (data.data) {
    console.group(`Additional Data`);
    try {
      console.log(JSON.parse(data.data));
    } catch (e) {
      console.log(data.data);
    }
    console.groupEnd();
  }
  console.groupEnd();

  console.groupCollapsed(`Raw Data`);
  console.log(data);
  console.groupEnd();

  console.groupEnd();
};

Resin.recordUserAction = attributes => {
  attributes.client = 'web';
  const docBody = get(document, 'body');
  if (!attributes.application) {
    attributes.application = docBody.getAttribute('data-resin-application');
  }
  if (!attributes.page) {
    attributes.page = docBody.getAttribute('data-resin-page');
  }

  const resinizedAttributes = mapValues(attributes, attribute =>
    typeof attribute === 'string' ? resinize(attribute) : attribute,
  );

  Resin.recordAction(resinizedAttributes);
};

export default Resin;
